import { useEffect } from "react";
import { useSelector } from "react-redux";
import { onSnapshot } from "firebase/firestore";
import throttle from "modules/throttle";
import { useAppDispatch } from "store/hooks";
import { selectCurrentEventId } from "modules/event/selectors";
import { getActivityStatusEventsRef } from "../../firebase";
import {
  IEventActivityStatusDocData,
  processEventActivityStatusMap,
} from "../../utils";
import { EventActivityStatusUserMap } from "../../types";
import { setUsersActivityStatus } from "../../redux/slice";

const UPDATE_THROTTLE_TIME = 500;

export const EventActivityStatusListener = (): null => {
  const dispatch = useAppDispatch();
  const eventId = useSelector(selectCurrentEventId);

  const throttledDispatch = throttle(
    (eventActivityStatusMap: EventActivityStatusUserMap) => {
      dispatch(setUsersActivityStatus(eventActivityStatusMap));
    },
    UPDATE_THROTTLE_TIME,
  );

  useEffect(() => {
    if (!eventId) return;

    const unsubscribe = onSnapshot(
      getActivityStatusEventsRef(eventId),
      (snapshot) => {
        const attendeeActivityStatuses = snapshot.docs.map((doc) =>
          doc.data(),
        ) as IEventActivityStatusDocData[];

        throttledDispatch(
          processEventActivityStatusMap(attendeeActivityStatuses),
        );
      },
    );

    // eslint-disable-next-line consistent-return
    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId]);

  return null;
};
